/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { ResourceQueryResult } from '@modules/role-assignments-lib/types'
import { useResourcesQuery as useResourcesQueryElasticsearch } from '@modules/role-assignments-lib/resource_query_provider/admin-elasticsearch-projects'
import { useResourcesQuery as useResourcesQueryObservability } from '@modules/role-assignments-lib/resource_query_provider/admin-observability-projects'
import { useResourcesQuery as useResourcesQuerySecurity } from '@modules/role-assignments-lib/resource_query_provider/admin-security-projects'
import { useResourcesQuery as useResourcesQueryConnectedClusters } from '@modules/role-assignments-lib/resource_query_provider/admin-connected-clusters'
import { useResourcesQuery as useResourcesQueryDeployments } from '@modules/role-assignments-lib/resource_query_provider/admin-deployments'

import type { UseQueryOptions } from 'react-query'

export const useGetOrganizationResourcesQuery = (
  organizationId: string,
  options?: Pick<UseQueryOptions, 'enabled'>,
): ResourceQueryResult[] => {
  const queryResults: ResourceQueryResult[] = [
    useResourcesQueryDeployments(organizationId, options),
    useResourcesQueryElasticsearch(organizationId, options),
    useResourcesQueryObservability(organizationId, options),
    useResourcesQuerySecurity(organizationId, options),
    useResourcesQueryConnectedClusters(organizationId, options),
  ]

  return queryResults.filter(({ isEnabled }) => isEnabled)
}
